<template>
  <div class="examineBox myStatementApply">
    <self-back :pageHeaderList="[{'name':'我的结算单盖章申请'}]"></self-back>
    <div class="containter" v-loading='loading'>
      <ul class="topTab">
        <!-- <li :class="tab == 1 ? 'active' : ''" @click="tab = 1;">销售结算单</li> -->
        <li :class="tab == 2 ? 'active' : ''" @click="tab = 2" v-if="userInfo.role_id != 11">MCN结算单</li>
        <li :class="tab == 5 ? 'active' : ''" @click="tab = 5" v-if="userInfo.role_id != 9">游戏/电商结算单</li>
        <li :class="tab == 6 ? 'active' : ''" @click="tab = 6" v-if="userInfo.role_id != 9">拼多多结算单</li>
        <li :class="tab == 4 ? 'active' : ''" @click="tab = 4" v-if="userInfo.role_id != 9">CPA结算单</li>
      </ul>
      <div style="margin: 0 16px 16px;" class="topSelect">
        <label>申请日期：</label>
        <el-date-picker @change="getStatementsIndex(1)" v-model="timeMonth" style="width:240px" type="daterange" size="mini" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" />
        <label>甲方名称：</label>
        <el-input placeholder="请输入甲方名称" v-model.trim="customer_name" clearable @keydown.enter.native="customer_name ? getStatementsIndex(1) : ''" @clear="getStatementsIndex(1)" size="mini" style="width:200px">
          <el-button slot="append" icon="el-icon-search" @click="customer_name ? getStatementsIndex(1) : ''" style="padding:0 10px" />
        </el-input>
      </div>
      <div class="listBox">
        <el-table class="table" :header-cell-style="{background:'#f5f7fa'}" :data="accountList" height="calc(100vh - 304px)" border>
          <el-table-column prop="statements_seal_id" label="盖章序列号" align='center' min-width="84" />
          <el-table-column prop="statements_id" label="结算单序列号" align='center' min-width="94" />
          <el-table-column prop="order_amount" label="订单金额" align='center' min-width="90" />
          <el-table-column prop="customer_name" label="甲方名称" align='center' min-width="200" />
          <el-table-column prop="company" label="签约公司" align='center' min-width="200" />
          <el-table-column prop="applicant_time" align='center' label="申请提交时间" min-width="160" />
          <el-table-column prop="type" align='center' label="申请类型" min-width="145">
            <template slot-scope="{ row }">
              <span v-if="row.type == 1">含本公司结算单盖章</span>
              <span v-else-if="row.type == 2">仅客户公司结算单盖章</span>
            </template>
          </el-table-column>
          <el-table-column prop="verify_note" align='center' label="审核状态" min-width="100">
            <template slot-scope="{ row }">
              <span :style="{color: getVerifyNoteColor(row.verify_status)}">{{ row.verify_note }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="seal_status" align='center' label="盖章状态" min-width="100">
            <template slot-scope="{ row }">
              <span v-if="row.seal_status == 1" style="color:#00BB5D">已盖章</span>
              <span v-else-if="row.seal_status == 0">未盖章</span>
            </template>
          </el-table-column>
          <el-table-column prop="seal_date" align='center' label="盖章日期" min-width="160">
            <template slot-scope="{ row }">
              <span v-if="row.seal_date">{{ row.seal_date }}</span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column prop="file_status" align='center' label="归档状态" min-width="100">
            <template slot-scope="{ row }">
              <span v-if="row.file_status == 1" style="color:#00BB5D">已归档</span>
              <span v-else-if="row.file_status == 0">未归档</span>
            </template>
          </el-table-column>
          <el-table-column prop="file_date" align='center' label="归档日期" min-width="160">
            <template slot-scope="{ row }">
              <span v-if="row.file_date">{{ row.file_date }}</span>
              <span v-else> - </span>
            </template>
          </el-table-column>
          <el-table-column align='center' label="操作" fixed="right" min-width="90">
            <template slot-scope="scope">
              <button class="detailButton" @click="onClickDetailBtn(scope.row)">申请详情</button>
              <button class="detailButton" style="background:#f66034" @click="statementsDelVerify(scope.row)">撤销申请</button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
          <el-pagination small background :current-page="page" :page-size="page_size" @current-change="handleCurrentChange" layout="total, prev, pager, next" :total="total" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getVerifyNoteColor } from '@/assets/js/tools.js'

export default {
  data () {
    return {
      page: 1,
      page_size: 20,
      total: 0,
      loading: false,
      tab: 2,
      accountList: [],
      timeMonth: '',
      customer_name: '',
      userInfo: {},
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
    if (this.userInfo.role_id == 11) {
      this.tab = 5;
    }
    this.getStatementsIndex(1)
  },
  methods: {
    getVerifyNoteColor,
    getStatementsIndex (page) {
      this.loading = true;
      this.page = page
      this.$axios.get(this.URL.BASEURL + this.URL.statementsSeal_applyList, {
        params: {
          statements_type: this.tab,
          applicant_date_st: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[0] : '',
          applicant_date_ed: this.timeMonth && this.timeMonth.length > 0 ? this.timeMonth[1] : '',
          customer_name: this.customer_name,
          page: page,
          page_size: this.page_size,
        }
      }).then((res) => {
        var res = res.data;
        this.loading = false;
        if (res && res.errno == 0) {
          this.accountList = res.rst.data;
          this.total = res.rst.pageInfo.total;
        } else {
          this.$message({
            message: res.err,
            type: 'warning'
          })
        }
      }).catch(() => {
        this.loading = false
      })
    },
    statementsDelVerify (data) {//撤销申请
      this.$confirm('确定要撤销此次申请', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = true;
        this.$axios.post(this.URL.BASEURL + this.URL.statementsSeal_del, {
          statements_seal_id: data.statements_seal_id
        }).then((res) => {
          var res = res.data;
          this.loading = false;
          if (res && res.errno == 0) {
            this.getStatementsIndex(this.page)
          } else {
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false
        })
      }).catch((action) => {
      });
    },
    handleCurrentChange (val) {
      this.getStatementsIndex(val)
    },
    onClickDetailBtn(row) {
      const routeData = this.$router.resolve({
        path: `/statementSealDetail/${this.tab}?seal_id=${row.statements_seal_id}&id=${row.statements_id}&enable_apply=${row.enable_apply ? row.enable_apply : ''}&sealType=${row.type}&action=1`,
      })
      this.$winopen(routeData.href)
    },
  },
  watch: {
    tab () {
      this.getStatementsIndex(1);
      this.customer_name = '';
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./statementApply.scss";
.item {
  margin-bottom: 20px;
  margin-left: 30px;
  label {
    color: #202652;
    font-size: 14px;
    line-height: 20px;
    display: inline-block;
    width: 50px;
    .stars {
      color: red;
    }
  }
}
</style>
<style lang="scss">
.myStatementApply {
  .el-range-editor--mini .el-range-separator {
    width: 20px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/myStatementSealApply.vue